import { a as _inherits, b as _createSuper, c as _createClass, d as _classCallCheck, i as _createForOfIteratorHelper, h as _wrapNativeSuper } from './_rollupPluginBabelHelpers-81f38430.js';

/**
 * Collection promo tiles are potentially rendered twice: once for desktop, once
 * for mobile, because there are two position controls.  This causes subtle issues
 * in the Shopify Theme Customizer because {{ block.shopify_attributes }} is rendered
 * in two places.  If the first instance is not visible (display: none) the theme
 * editor will scroll to 0 instead of scrolling the element into view.
 *
 * To work around this this custom element simply removes the data-shopify attribute
 * when the element is not visible.
 */
var CollectionPromoTile = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CollectionPromoTile, _HTMLElement);
  var _super = _createSuper(CollectionPromoTile);
  function CollectionPromoTile() {
    _classCallCheck(this, CollectionPromoTile);
    return _super.apply(this, arguments);
  }
  _createClass(CollectionPromoTile, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      this.shopifyAttrs = {};
      var _iterator = _createForOfIteratorHelper(this.attributes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var attr = _step.value;
          if (attr.name.startsWith("data-shopify")) {
            this.shopifyAttrs[attr.name] = attr.value;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (Object.keys(this.shopifyAttrs).length === 0) return;
      this.visibility = this.dataset.breakpointVisibility;
      if (!this.visibility || this.visibility === "all") return;
      this.controller = new AbortController();
      this.eventOptions = {
        signal: this.controller.signal
      };
      this.mediaQuery = window.matchMedia("(min-width: 720px)");
      this.mediaQuery.addEventListener("change", function () {
        return _this.updateShopifyAttrs();
      }, this.eventOptions);
      this.updateShopifyAttrs();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this$controller;
      (_this$controller = this.controller) === null || _this$controller === void 0 ? void 0 : _this$controller.abort();
    }
  }, {
    key: "updateShopifyAttrs",
    value: function updateShopifyAttrs() {
      var isDesktop = this.mediaQuery.matches;
      var visible = this.visibility === "desktop-only" && isDesktop || this.visibility === "mobile-only" && !isDesktop;
      for (var _i = 0, _Object$keys = Object.keys(this.shopifyAttrs); _i < _Object$keys.length; _i++) {
        var name = _Object$keys[_i];
        if (visible) {
          this.setAttribute(name, this.shopifyAttrs[name]);
        } else {
          this.removeAttribute(name);
        }
      }
    }
  }]);
  return CollectionPromoTile;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get("collection-promo-tile")) {
  customElements.define("collection-promo-tile", CollectionPromoTile);
}

export { CollectionPromoTile as default };
